interface SectionTitleBarProps {
  text: string;
}

/**
 * Full-width pill title bar between sections (e.g. "3. Voies d'activation plaquettaire").
 */
export function SectionTitleBar({ text }: SectionTitleBarProps) {
  return (
    <div
      className="flex items-center justify-center my-[14px] mt-[26px] font-gloock text-[22px] text-ink"
      style={{ letterSpacing: '0.03em' }}
    >
      <span className="bg-white border-[2.5px] border-ink rounded-full px-[18px] pt-[5px] pb-[3px] shadow-ink">
        {text}
      </span>
    </div>
  );
}
